<template>
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7833 1.43764L10.7833 1.43764L10.7848 1.43513C10.8309 1.35419 10.9096 1.3125 10.9996 1.3125C11.0871 1.3125 11.1664 1.35238 11.216 1.4379C11.2161 1.43799 11.2162 1.43808 11.2162 1.43818L20.9653 18.3117C20.9654 18.3118 20.9655 18.312 20.9656 18.3121C21.0623 18.481 20.9406 18.6875 20.7496 18.6875H1.24962C1.0586 18.6875 0.936993 18.4811 1.03361 18.3122C1.03371 18.312 1.0338 18.3118 1.0339 18.3117L10.7833 1.43764ZM2.6026 17.1585L2.16927 17.9086H3.03555H18.9637H19.83L19.3966 17.1585L11.4326 3.37254L10.9996 2.6231L10.5667 3.37254L2.6026 17.1585ZM10.5577 15.3169C10.4405 15.1997 10.3746 15.0408 10.3746 14.875C10.3746 14.7092 10.4405 14.5503 10.5577 14.4331C10.6749 14.3158 10.8339 14.25 10.9996 14.25C11.1654 14.25 11.3243 14.3158 11.4416 14.4331C11.5588 14.5503 11.6246 14.7092 11.6246 14.875C11.6246 15.0408 11.5588 15.1997 11.4416 15.3169C11.3243 15.4342 11.1654 15.5 10.9996 15.5C10.8339 15.5 10.6749 15.4342 10.5577 15.3169ZM11.2496 11.75H10.7496V8.0625H11.2496V11.75Z"
      fill="white"
      stroke="white"
    />
  </svg>
</template>
